// mobile路由配置
export var mobileRoutes = [
    {
        path: "/",
        exact: true,
        trunk: function () { return import("@/pages/main"); },
    },
    {
        path: "/main",
        exact: true,
        trunk: function () { return import("@/pages/main"); },
    },
    {
        path: "/help",
        exact: true,
        trunk: function () { return import("@/pages/help"); },
    },
    {
        path: "/sign",
        exact: true,
        trunk: function () { return import("@/pages/sign"); },
    },
    {
        path: "/payment",
        exact: true,
        trunk: function () { return import("@/pages/payment/list"); },
    },
    {
        path: "/preview",
        exact: true,
        trunk: function () { return import("@/pages/preview"); },
    },
    {
        path: "/billDetail",
        exact: true,
        trunk: function () { return import("@/pages/billDetail"); },
    },
    {
        path: "/invoicePDF",
        exact: true,
        trunk: function () { return import("@/pages/pdf"); },
    }
];
// 系统路由配置
export var pcRoutes = [
    {
        path: "/",
        exact: true,
        trunk: function () { return import("@/pages/main"); },
    },
    {
        path: "/main",
        exact: true,
        trunk: function () { return import("@/pages/main"); },
    },
    {
        path: "/help",
        exact: true,
        trunk: function () { return import("@/pages/help"); },
    },
    {
        path: "/invoicePDF",
        exact: true,
        trunk: function () { return import("@/pages/pdf"); },
    }
];
// 追签的footer
export var signatureFooter = [
    {
        pathName: "/",
        icon: require("@/common/png/main.png"),
        activeIcon: require("@/common/png/main1.png"),
        title: "list"
    },
    {
        pathName: "/preview",
        icon: require("@/common/png/preview.png"),
        activeIcon: require("@/common/png/preview1.png"),
        title: "preview"
    },
    {
        pathName: "/help",
        icon: require("@/common/png/help.png"),
        activeIcon: require("@/common/png/help1.png"),
        title: "help"
    }
];
// 追账的footer
export var paymentFooter = [
    {
        pathName: "/",
        icon: require("@/common/png/main.png"),
        activeIcon: require("@/common/png/main1.png"),
        title: "list"
    },
    {
        pathName: "/help",
        icon: require("@/common/png/help.png"),
        activeIcon: require("@/common/png/help1.png"),
        title: "help"
    }
];
